export const ERROR_TRANSLATIONS = {
  title: 'successStories.error.title',
  description: 'successStories.error.description',
};
